import React from 'react';
import { Zap } from 'lucide-react';

interface LogoProps {
  color?: 'dark' | 'white';
}

const Logo: React.FC<LogoProps> = ({ color = 'dark' }) => {
  const textColor = color === 'white' ? 'text-white' : 'text-gray-900';
  const iconColor = color === 'white' ? 'text-primary-300' : 'text-primary-600';
  
  return (
    <div className="flex items-center">
      <Zap className={`h-8 w-8 ${iconColor}`} />
      <div className="ml-2">
        <span className={`text-xl font-bold ${textColor}`}>
          Пром<span className="text-accent-500">иннова</span>
        </span>
      </div>
    </div>
  );
};

export default Logo;